import { AudioLines, ArrowLeft, Crown } from "lucide-react";

export default function ComingSoon() {
  return (
    <section
      className="relative flex min-h-screen items-center justify-center overflow-hidden px-5 py-24"
      aria-labelledby="coming-soon-heading"
      data-testid="coming-soon-page"
    >
      <div
        className="pointer-events-none absolute left-1/2 top-1/3 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#2563EB]/22 blur-[130px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-2xl text-center">
        <span className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-[#2563EB] to-[#00D4FF] shadow-[0_0_40px_rgba(0,212,255,0.4)]">
          <AudioLines className="h-10 w-10 text-white" strokeWidth={2.2} aria-hidden="true" />
        </span>
        <p className="mb-5 inline-block rounded-full border border-[#00D4FF]/30 bg-[#0C2340]/70 px-4 py-2 text-xs font-semibold uppercase tracking-[0.25em] text-[#00D4FF]">
          App In Development
        </p>
        <h1 id="coming-soon-heading" className="font-display text-3xl font-black tracking-tight text-white sm:text-4xl lg:text-5xl">
          The VoiceLens AI app is <span className="text-glow-gradient">almost here.</span>
        </h1>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
          We're putting the finishing touches on the reading experience. Founders get first access
          the moment it launches — with lifetime locked-in pricing.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="/#pricing"
            data-testid="coming-soon-founder-button"
            className="inline-flex min-h-[56px] items-center gap-3 rounded-full bg-[#2563EB] px-8 py-4 text-base font-bold text-white shadow-[0_0_30px_rgba(37,99,235,0.5)] transition-all duration-300 hover:scale-[1.03] hover:bg-[#1D4ED8]"
          >
            <Crown className="h-5 w-5" aria-hidden="true" />
            Become a Founder — $2.99/mo
          </a>
          <a
            href="/"
            data-testid="coming-soon-home-button"
            className="inline-flex min-h-[56px] items-center gap-3 rounded-full border border-[#00D4FF]/35 px-8 py-4 text-base font-semibold text-slate-100 transition-all duration-300 hover:border-[#00D4FF]/70 hover:bg-[#00D4FF]/10"
          >
            <ArrowLeft className="h-5 w-5" aria-hidden="true" />
            Back to Home
          </a>
        </div>
      </div>
    </section>
  );
}
